import React from "react";
import {
  SubTitleTab,
  TitleTab,
} from "../../../../../../component/page-components";
import { DatePicker, Input, Radio } from "antd";
import Dragger from "../../../../../../component/dragger/Dragger";
import DropdownListTitle from "../../../../../../component/dropdown-list/ddl-title";
import DropdownListMaritalStatus from "../../../../../../component/dropdown-list/ddl-marital-status";
import style from "../../DeliveryAssociate.module.css";
import onKeyPressNumber from "../../../../../../util/onKeyPressNumber";

const DriverProfileOutsource = ({
  handleChangeGender,
  gender,
  selectedFileList,
  setSelectedFileList,
  err,
  error,
  handleFormInput,
  FormInput,
  setPersonTitle,
  personTitle,
  maritalStatus,
  setMaritalStatus,
  handleFormInputDate,
  FormInputDate,
  FormError,
}) => {
  return (
    <div className="columns mt-5">
      <div className="container-field">
        <SubTitleTab title="Driver Photo (Optional)" />
        <Dragger
          selectedFileList={selectedFileList}
          setSelectedFileList={setSelectedFileList}
        />
      </div>

      <div className="container-field">
        <SubTitleTab title="Title (Optional)" />
        <DropdownListTitle
          placeholder="Select Title"
          setValueDDS={setPersonTitle}
          valueDDS={personTitle}
        />
        <div className="text-red-100">{err ? err : error?.title}</div>
      </div>

      <div className='container-field'>
        <SubTitleTab title="First Name" />
        <Input
          size="large"
          placeholder="Type First Name"
          onChange={(evt) => {
            handleFormInput(evt.target.value, "first_name");
          }}
          value={FormInput?.first_name}
          status={FormError?.first_name ? "error" : null}
        />
        <div className="text-red-100">
          {FormError?.first_name ? FormError?.first_name : false}
        </div>
      </div>

      <div className="container-field">
        <SubTitleTab title="Last Name (Optional)" />
        <Input
          size="large"
          placeholder="Type Last Name"
          onChange={(evt) => {
            handleFormInput(evt.target.value, "last_name");
          }}
          value={FormInput?.last_name}
          status={FormError?.last_name ? "error" : null}
        />
        <div className="text-red-100">
          {FormError?.last_name ? FormError?.last_name : false}
        </div>
      </div>

      <div className="container-field">
        <SubTitleTab title="ID Card/NIK" />
        <Input
          size="large"
          placeholder="Type ID Card/NIK"
          onChange={(evt) => {
            handleFormInput(evt.target.value, "nik");
          }}
          value={FormInput?.nik}
          status={FormError?.nik ? "error" : null}
        />
        <div className="text-red-100">
          {FormError?.nik ? FormError?.nik : false}
        </div>
      </div>

      <div className="container-field">
        <SubTitleTab title="Phone" />
        <Input
          size="large"
          placeholder="Type Phone"
          onKeyPress={(e) => onKeyPressNumber(e)}
          onChange={(evt) => {
            handleFormInput(evt.target.value, "phone");
          }}
          value={FormInput?.phone}
          addonBefore="+62"
          maxLength={13}
          status={FormError?.phone ? "error" : null}
        />
        <div className="text-red-100">
          {FormError?.phone ? FormError?.phone : false}
        </div>
      </div>

      <div className='container-field'>
        <SubTitleTab title="E-mail" />
        <Input
          size="large"
          placeholder="Type E-mail"
          onChange={(evt) => {
            handleFormInput(evt.target.value, "email");
          }}
          value={FormInput?.email}
          status={FormError?.email ? "error" : null}
        />
        <div className="text-red-100">
          {FormError?.email ? FormError?.email : false}
        </div>
      </div>

      <div className="container-field">
        <SubTitleTab title="Marital Status (Optional)" />
        <DropdownListMaritalStatus
          placeholder="Select Marital Status"
          setValueDDS={setMaritalStatus}
          valueDDS={maritalStatus}
        />
        <div className="text-red-100">{err ? err : error?.marital_status}</div>
      </div>

      <div className="container-field">
        <SubTitleTab title="Gender (Optional)" />
        <Radio.Group
          onChange={(evt) => handleChangeGender(evt.target.value)}
          value={gender}
          className={style.radioBtn}
        >
          <Radio value="M" className=" font-roboto-medium text-[20px]">
            Male
          </Radio>
          <Radio value="F" className=" font-roboto-medium text-[20px]">
            Female
          </Radio>
        </Radio.Group>
      </div>

      <div className="container-field">
        <SubTitleTab title="Birthplace (Optional)" />
        <Input
          size="large"
          placeholder="Type Birthplace"
          onChange={(evt) => {
            handleFormInput(evt.target.value, "birth_place");
          }}
          value={FormInput?.birth_place}
          status={error?.birth_place ? "error" : null}
        />
        <div className="text-red-100">{err ? err : error?.birth_place}</div>
      </div>

      <div className='container-field'>
        <SubTitleTab title="Birthdate (Optional)" />
        <DatePicker
          style={{ width: "100%" }}
          size="large"
          format="DD MMMM YYYY"
          placeholder="Select Birthdate"
          onChange={(evt) => {
            handleFormInputDate(evt, "date_of_birth");
          }}
          allowClear={true}
          status={error?.date_of_birth ? "error" : null}
          value={
            FormInputDate?.date_of_birth
              ? FormInputDate?.date_of_birth
              : undefined
          }
        />
        <div className="text-red-100">{err ? err : error?.date_of_birth}</div>
      </div>

      <TitleTab title="Emergency Contact" />

      <div className='container-field'>
        <SubTitleTab title="Name" />
        <Input
          size="large"
          placeholder="Type Name"
          onChange={(evt) => {
            handleFormInput(evt.target.value, "emergency_contact_name");
          }}
          value={FormInput?.emergency_contact_name}
          status={FormError?.emergency_contact_name ? "error" : null}
        />
        <div className="text-red-100">
          {FormError?.emergency_contact_name
            ? FormError?.emergency_contact_name
            : false}
        </div>
      </div>

      <div className="container-field">
        <SubTitleTab title="Relationship (Optional)" />
        <Input
          size="large"
          placeholder="Type Relationship"
          onChange={(evt) => {
            handleFormInput(evt.target.value, "emergency_contact_relationship");
          }}
          value={FormInput?.emergency_contact_relationship}
          status={error?.emergency_contact_relationship ? "error" : null}
        />
        <div className="text-red-100">
          {err ? err : error?.emergency_contact_relationship}
        </div>
      </div>

      <div className='container-field'>
        <SubTitleTab title="Phone" />
        <Input
          size="large"
          placeholder="Type Phone"
          onKeyPress={(e) => onKeyPressNumber(e)}
          onChange={(evt) => {
            handleFormInput(evt.target.value, "emergency_contact_no_hp");
          }}
          value={FormInput?.emergency_contact_no_hp}
          addonBefore="+62"
          maxLength={13}
          status={FormError?.emergency_contact_no_hp ? "error" : null}
        />
        <div className="text-red-100">
          {FormError?.emergency_contact_no_hp
            ? FormError?.emergency_contact_no_hp
            : false}
        </div>
      </div>

      <div className="container-field">
        <SubTitleTab title="Address" />
        <Input
          size="large"
          placeholder="Type Address"
          onChange={(evt) => {
            handleFormInput(evt.target.value, "emergency_contact_address");
          }}
          value={FormInput?.emergency_contact_address}
          status={FormError?.emergency_contact_address ? "error" : null}
        />
        <div className="text-red-100">
          {FormError?.emergency_contact_address
            ? FormError?.emergency_contact_address
            : false}
        </div>
      </div>
    </div>
  );
};

export default DriverProfileOutsource;
